import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import SectionHeading from "@/components/base/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import HeroSection from "@/pages/home/components/HeroSection";
import FocusBoard from "@/pages/home/components/FocusBoard";
import HotRanking from "@/pages/home/components/HotRanking";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import HotEntries from "@/pages/home/components/HotEntries";
import VoiceSection from "@/pages/home/components/VoiceSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";
import { faqs } from "@/mocks/faqs";
import { getHotEntries } from "@/hooks/useSiteData";
import { useSEO, SITE_ORIGIN } from "@/hooks/useSEO";

const homeFaqs = faqs.slice(0, 6);

export default function Home() {
  useSEO({
    title: "黑料百科 - 娱乐人物词条与话题档案库",
    description:
      "黑料百科收录明星、网红、艺人的人物词条与话题档案，按分类与热度整理事件时间线，人物背景、话题脉络一网打尽，吃瓜群众必备参考。",
    keywords: "黑料百科,人物词条,明星词条,网红词条,艺人档案,黑历史,人物背景",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "黑料百科",
        url: SITE_ORIGIN,
        description: "娱乐人物词条与话题档案库，按时间线整理公开信息。",
        inLanguage: "zh-CN",
        publisher: { "@type": "Organization", name: "黑料百科" },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "黑料百科",
        url: SITE_ORIGIN,
        email: "editor@heiliaobaike.com",
        description: "以人物为单位整理娱乐话题时间线的内容站点。",
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "本周热度词条榜",
        itemListElement: getHotEntries(8).map((entry, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: entry.title,
          url: `${SITE_ORIGIN}/entry/${entry.id}`,
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: homeFaqs.map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: { "@type": "Answer", text: item.answer },
        })),
      },
    ],
  });

  return (
    <SiteLayout>
      <HeroSection />
      <FocusBoard />
      <HotRanking />
      <CategoryGrid />
      <HotEntries />
      <VoiceSection />

      <section className="border-b border-background-200 bg-background-100/60 px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="常见问题"
          title="第一次来，先看这几条"
          desc="关于词条结构、信息来源与纠错方式，这里一次说清楚。"
          linkText="全部问题"
          linkTo="/faq"
        />
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[2fr_1fr]">
          <FaqAccordion items={homeFaqs} />
          <aside className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h3 className="font-heading text-base font-bold text-foreground-950">还没找到答案？</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              可以给我们留言，说明你想了解的话题或需要纠错的内容，我们会逐一核对。
            </p>
            <Link
              to="/contact"
              className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-chat-3-line"></i>
              去留言
            </Link>
            <div className="mt-5 space-y-2 border-t border-background-200 pt-4 text-xs text-foreground-500">
              <p className="flex items-center gap-2">
                <i className="ri-time-line"></i> 工作日 24 小时内回复
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-mail-line"></i> editor@heiliaobaike.com
              </p>
            </div>
          </aside>
        </div>
      </section>

      <SubscribeSection />
    </SiteLayout>
  );
}